import { getterTree } from "typed-vuex";
import { ActionDefinition, ActionType } from "@wl/types/lib/types/actions/definition";
import { ActionDefinitionHistory } from "@wl/types/lib/types/actions/history";
import state, { ActionState } from "./state";

/**
 * Action module getters.
 */
const getters = getterTree(state, {
    /**
     * Returns all active quest definitions.
     *
     * @param {ActionState} state Action state
     * @return {ActionDefinition[]} All active quest definitions
     */
    quests(state: ActionState): ActionDefinition[] {
        const quests = state.active.filter(def => def.type === ActionType.Quest);
        const mainQuests = quests.filter(q => !q.dependsOn).map(q => q.id);

        return quests.filter(q => (q.dependsOn ? !mainQuests.includes(q.dependsOn) : true));
    },

    /**
     * Returns all active achievement definitions.
     *
     * @param {ActionState} state Action state
     * @return {ActionDefinition[]} All active achievement definitions
     */
    achievements(state: ActionState): ActionDefinition[] {
        const quests = state.active.filter(def => def.type === ActionType.Quest);
        const mainQuests = quests.filter(q => !q.dependsOn).map(q => q.id);

        return state.active
            .filter(def => def.type === ActionType.Achievement)
            .filter(q => (q.dependsOn ? !mainQuests.includes(q.dependsOn) : true));
    },

    /**
     * Returns all history quest definitions.
     *
     * @param {ActionState} state Action state
     * @return {ActionDefinitionHistory[]} History quest definitions
     */
    questHistory(state: ActionState): ActionDefinitionHistory[] {
        return state.history.filter(entry => entry.definition.type === ActionType.Quest);
    },

    /**
     * Returns all history achievement definitions.
     *
     * @param {ActionState} state Action state
     * @return {ActionDefinitionHistory[]} History achievement definitions
     */
    achievementHistory(state: ActionState): ActionDefinitionHistory[] {
        return state.history.filter(entry => entry.definition.type === ActionType.Achievement);
    },
});

export default getters;
